"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "@phosphor-icons/react/dist/ssr";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Button } from "@/src/components/ui/Button";
import { Heading, Text } from "@/src/components/ui/Typography";
import { paths } from "@/src/routes/paths";

import { sectorItems } from "./data";
import { SectorRow } from "./SectorRow";

export function SectorsWeServe() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState<"up" | "down">("down");
  const prevIndex = useRef(0);

  const handleHover = (index: number) => {
    if (index === activeIndex) return;
    setDirection(index > prevIndex.current ? "down" : "up");
    prevIndex.current = index;
    setActiveIndex(index);
  };

  const handleLeave = () => handleHover(0);

  useEffect(() => {
    const applyHash = () => {
      const slug = window.location.hash.slice(1);
      if (!slug) return;

      const index = sectorItems.findIndex((item) => item.slug === slug);
      if (index === -1) return;

      prevIndex.current = index;
      setActiveIndex(index);
    };

    applyHash();

    window.addEventListener("hashchange", applyHash);
    return () => window.removeEventListener("hashchange", applyHash);
  }, []);

  return (
    <Section className="bg-neutral-100">
      <Container>
        <Heading as="h2" size="displayLG" className="max-w-150">
          Sectors We Serve
        </Heading>

        <Text size="bodyLG" className="mt-4 max-w-150 text-neutral-600">
          TechEniac specializes in industries where AI creates measurable
          outcomes. Our experience comes from building and delivering
          solutions that work in real environments, not just in theory.
        </Text>

        <div className="mt-8">
          <Button
            href={paths.caseStudies.root}
            variant="link"
            className="pl-0"
          >
            See our work
          </Button>
        </div>

        <div
          onMouseLeave={handleLeave}
          className="mt-16 flex flex-col border-t border-neutral-200"
        >
          {sectorItems.map((item, index) => (
            <SectorRow
              key={item.slug}
              item={item}
              active={index === activeIndex}
              direction={direction}
              onHover={() => handleHover(index)}
            />
          ))}
        </div>
      </Container>
    </Section>
  );
}
